import { type FC, useEffect, useRef, useState } from 'react';
import { ListGroup } from 'react-bootstrap';
import { BsThreeDotsVertical } from 'react-icons/bs';

interface Props {
	label: string;
	index: number;
	readOnly: boolean;
	onAddColumnClick: (_) => void;
	onDeleteColumnClick: (_) => void;
}

const ColumnHeader: FC<Props> = (props) => {
	const { label, index, readOnly, onAddColumnClick, onDeleteColumnClick } = props;

	const [showDropdown, setShowDropdown] = useState(false);
	const ref = useRef(null);

	const onAddColumn = (index: number) => {
		onAddColumnClick(index + 1);
		setShowDropdown(false);
	};

	const onDeleteColumn = (index: number) => {
		// eslint-disable-next-line no-alert
		if (window.confirm(`Are you sure to delete the column "${label}" ?`)) {
			onDeleteColumnClick(index);
		}
		setShowDropdown(false);
	};

	const handleClickOutside = (event) => {
		if (ref.current && !ref.current.contains(event.target)) {
			setShowDropdown(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});

	return (
		<div className="addColumn">
			<span>{label}</span>
			<BsThreeDotsVertical className="addButton" onClick={() => setShowDropdown(!showDropdown)} />

			{showDropdown && (
				<ListGroup className="columnDropdown" ref={ref}>
					<ListGroup.Item className="dropdownItem" onClick={() => onAddColumn(index)}>
						Add column
					</ListGroup.Item>

					{!readOnly && (
						<ListGroup.Item className="dropdownItem" onClick={() => onDeleteColumn(index)}>
							Delete column
						</ListGroup.Item>
					)}
				</ListGroup>
			)}
		</div>
	);
};

export default ColumnHeader;
